import { createContext } from 'react';

export default createContext({
  results: [],
  generatedAt: ''
});
